import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'eyrus-warning-modal',
  templateUrl: './warning-modal.component.html',
  styleUrls: ['./warning-modal.component.sass']
})
export class EyrusWarningModalComponent implements OnInit {

  @Input() message: String = 'common.answerDelete';
  @Input() title: String = '';
  @Input() accept: String = 'common.yes';
  @Input() deny: String = 'common.no';

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal
  ) {

  }

  ngOnInit() {
  }

  confirm() {
    this.activeModal.close(true);
  }

  close() {
    this.activeModal.close(false);
  }

}
